import {Component, OnInit, ViewChild} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import {RegistryService} from "../../services/domain/registry.service";
import {UtilsService} from "../../services/utils.service";
import {
  AnagraficaDto, AnagraficaUtentePortalePagineCompilate,
  AnagraficaUtenteVarieCVDataDto
} from "../../models/anagrafica.models";
import {PlaceService} from "../../services/domain/place.service";
import {ComuniDto, NazioniDto} from "../../models/comuni.models";
import {SafeResourceUrl} from "@angular/platform-browser";
import {AuthService} from "../../services/auth.service";
import {ConfirmationService} from "primeng/api";
import {DocumentService} from "../../services/domain/document.service";
import {saveAs} from "file-saver";

@Component({
  selector: 'app-registry',
  templateUrl: './registry.component.html',
  styleUrls: ['./registry.component.css'],
  providers : [RegistryService,PlaceService,ConfirmationService,DocumentService]
})

export class RegistryComponent extends BasePageComponent implements OnInit{

  constructor(private registryService : RegistryService,
              private placeService : PlaceService,
              private confirmationService : ConfirmationService,
              private documentService : DocumentService) {
    super();

  }
  @ViewChild('profilePhoto') profilePhotoFile : any;
  @ViewChild('profileCv') profileCvFile : any;
  public registryDto : AnagraficaDto = new AnagraficaDto();
  public comuniList : ComuniDto[] = [];
  public nazioniList : NazioniDto[] = [];
  public comuneResidenzaSelezionato : ComuniDto = new ComuniDto();
  public comuneDomicilioSelezionato : ComuniDto = new ComuniDto();
  public nazioneSelezionata : NazioniDto = new NazioniDto();
  public submittedPage : boolean = false;
  public durataMembroSapiens : string = '';
  public registryOtherInfo : AnagraficaUtenteVarieCVDataDto = new AnagraficaUtenteVarieCVDataDto();
  public srcCv : string = "";
  public blobCv : Blob = new Blob();
  public fileName : string = "Cv.pdf";
  public showModalCv : boolean = false;
  public worldName : string = "";
  public baseImagePath : string = "";
  public cvLoaded : boolean = false;
  public profileSex : string = "";

  ngOnInit(): void {
    this.getRegistryDetail();
    this.baseImagePath = this.authService.baseImagePath;
    if(this.authService.baseImagePath == "evo"){
      this.worldName = "Evo";
    }else{
      this.worldName = "Sapiens";
    }
    this.registryService.getProfileCv().subscribe(response => {
      if (response.size != 0) {
        this.cvLoaded = true;
      }
    });
  }

  public downloadProfileCv(){
    this.showSpinner();
    this.registryService.getProfileCv().subscribe(response => {
      if(response.size == 0){
        return this.showWarning("Cv non ancora inserito");
      }
      this.blobCv = new Blob([response], {type: response.type});
      saveAs(this.blobCv, "Cv.pdf");
    },error => {
      this.hideSpinner();
      this.showWarning("Cv non ancora inserito");
    },() =>
    {
      this.hideSpinner();
    })
  }

  public showProfileCv(){
    this.showSpinner();
    this.registryService.getProfileCv().subscribe(response => {
      if(response.size == 0){
        return this.showWarning("Cv non ancora inserito");
      }
      this.blobCv = new Blob([response], {type: response.type});
      this.authService.getSrcFromBlob(this.blobCv).then((value) => {
        this.srcCv = value;
        this.showModalCv = true;
      });
    },error => {
      this.hideSpinner();
      this.showWarning("Cv non ancora inserito");
    },() =>
    {
      this.hideSpinner();
    })
  }

  public getRegistryDetail(){
    this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
      this.registryDto = response.Item || new AnagraficaDto();
      this.comuneResidenzaSelezionato = new ComuniDto();
      this.comuneDomicilioSelezionato = new ComuniDto();
      this.nazioneSelezionata = new NazioniDto();
      this.comuneResidenzaSelezionato.ComuneDescrizione = this.registryDto.ComuneResidenza;
      this.comuneResidenzaSelezionato.IdComune = this.registryDto.IdComuneResidenza;
      this.comuneDomicilioSelezionato.ComuneDescrizione = this.registryDto.ComuneDomicilio;
      this.comuneDomicilioSelezionato.IdComune = this.registryDto.IdComuneDomicilio;
      this.nazioneSelezionata.NazioneNome = this.registryDto.NazioneCittadinanza;
      this.nazioneSelezionata.IdNazione = this.registryDto.IdNazioneCittadinanza;
      this.setDatesObjects();
      if(this.registryDto.IndirizzoResidenza == this.registryDto.IndirizzoDomicilio)
        this.registryDto.ResidenzaCombaciaConDomicilio = true;
      else
        this.registryDto.ResidenzaCombaciaConDomicilio = false;

      this.profileSex = this.registryDto.Sesso;

      this.getInfoAvailability();
    });
  }

  public getInfoAvailability(){
    this.asyncCall(() => this.registryService.getInfoAvailabilityAndCv(this.registryDto.IdAnagraficaUtente), response => {
      this.registryOtherInfo = response.Item || new AnagraficaUtenteVarieCVDataDto();
      if(this.registryOtherInfo != null){
        if(this.registryOtherInfo.VarieCV != null){
          this.registryDto.Automunito = this.registryOtherInfo.VarieCV.Automunito;
          this.registryDto.CategoriaProtetta = this.registryOtherInfo.VarieCV.CategoriaProtetta;
          this.registryDto.PatenteA = this.registryOtherInfo.VarieCV.PatenteA;
          this.registryDto.PatenteB = this.registryOtherInfo.VarieCV.PatenteB;
          this.registryDto.PatenteC = this.registryOtherInfo.VarieCV.PatenteC;
          this.registryDto.PatenteD = this.registryOtherInfo.VarieCV.PatenteD;
          this.registryDto.PatenteE = this.registryOtherInfo.VarieCV.PatenteE;
          if(this.registryOtherInfo.DisponibilitaOrario.length > 0)
            this.registryDto.DisponibilitaOrarioList = "";
          for(let i=0; i < this.registryOtherInfo.DisponibilitaOrario.length; i++){
            if(i == this.registryOtherInfo.DisponibilitaOrario.length -1){
              this.registryDto.DisponibilitaOrarioList += this.registryOtherInfo.DisponibilitaOrario[i].IdDisponibilitaOrario.toString();
            }
            else{
              this.registryDto.DisponibilitaOrarioList += this.registryOtherInfo.DisponibilitaOrario[i].IdDisponibilitaOrario.toString() + ",";
            }
          }
          if(this.registryOtherInfo.CorsiFormazione.length > 0)
            this.registryDto.IdCorsoList = "";
          for(let i = 0; i < this.registryOtherInfo.CorsiFormazione.length; i++){
            if( i == this.registryOtherInfo.CorsiFormazione.length - 1){
              this.registryDto.IdCorsoList += this.registryOtherInfo.CorsiFormazione[i].IdCorso.toString();
            }
            else{
              this.registryDto.IdCorsoList += this.registryOtherInfo.CorsiFormazione[i].IdCorso.toString() + ",";
            }
          }
        }
      }
    });
  }

  public registryUpdate(){
    if(this.nazioneSelezionata != null){
      if(this.nazioneSelezionata.IdNazione != null && this.nazioneSelezionata.IdNazione > 0){
        this.registryDto.IdNazioneCittadinanza = this.nazioneSelezionata.IdNazione;
      }
    }

    if(this.comuneResidenzaSelezionato != null){
      if(this.comuneResidenzaSelezionato.IdComune != null && this.comuneResidenzaSelezionato.IdComune > 0){
        this.registryDto.IdComuneResidenza = this.comuneResidenzaSelezionato.IdComune;
        if(this.registryDto.ResidenzaCombaciaConDomicilio){
          this.registryDto.IdComuneDomicilio = this.comuneResidenzaSelezionato.IdComune;
          this.registryDto.IndirizzoDomicilio = this.registryDto.IndirizzoResidenza;
        }
      }
      else{
        this.showError("Inserire un comune di residenza valido");
        this.comuneResidenzaSelezionato = new ComuniDto();
        this.comuneResidenzaSelezionato.ComuneDescrizione = "";
        return;
      }
    }

    if(!this.registryDto.ResidenzaCombaciaConDomicilio){
      if(this.comuneDomicilioSelezionato != null){
        if(this.comuneDomicilioSelezionato.IdComune != null && this.comuneDomicilioSelezionato.IdComune > 0){
          this.registryDto.IdComuneDomicilio = this.comuneDomicilioSelezionato.IdComune;
        }
      }
    }

    if(this.nazioneSelezionata.IdNazione == 0 || this.nazioneSelezionata.IdNazione == null
      || this.registryDto.IndirizzoResidenza == null || this.registryDto.IndirizzoResidenza == ""
      || this.registryDto.IdComuneResidenza == null || this.registryDto.IdComuneResidenza == 0
      || this.registryDto.IndirizzoDomicilio == null || this.registryDto.IndirizzoDomicilio == ""
      || this.registryDto.IdComuneDomicilio == null || this.registryDto.IdComuneDomicilio == 0){
      this.showError("Errore nel salvataggio dei dati: inserire tutti i campi obbligatori.");
    }
    else {
      this.asyncCall(() => this.registryService.registryUpdate(this.registryDto), response => {
        if (response.IsSuccess)
          this.showMessageSaveCompleted();
        else {
          var errorMsg = response.ErrorMessage;
          this.showError("Errore nel salvataggio dei dati: inserire tutti i campi obbligatori.");
        }
      });
    }
  }

  public getComuniAutoComplete(event : any){
    if(event == null)
      return;
    if(event.query.length < 3)
      return;

    this.asyncCall(() => this.placeService.getPlaceAutocomplete(event.query), response => {
      this.comuniList = response.Items || [];
    });
  }

  public getNazioniAutoComplete(event : any){
    if(event == null)
      return;
    if(event.query.length < 3)
      return;

    this.asyncCall(() => this.placeService.getNationAutocomplete(event.query), response => {
      this.nazioniList = response.Items || [];
    });
  }

  public loadProfileCvClick(){
    this.profileCvFile.nativeElement.click();
  }

  public loadProfileCv(event : any){
    this.confirmationService.confirm({
      message: 'Vuoi caricare il cv selezionato?',
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const fileProfileToUpload = event.files[0]
        if(fileProfileToUpload != null)
          this.loadProfileCvApi(fileProfileToUpload);
      }
    });
  }

  private loadProfileCvApi(file: File){
    if(file.type != 'application/pdf'){
      return this.showError("Caricare un file PDF");
    }
    this.asyncCall(() => {
      let formData = new FormData();
      formData.append("file", file, file.name);
      return this.documentService.updateProfileCv(AuthService.LoggedUser?.profileId ?? 0,formData);
    }, () => {
      this.showMessageSaveCompleted();
      this.showProfileCv();
      this.cvLoaded = true;
    });
  }

  private setDatesObjects(): void {
    if(this.registryDto.DataNascita != null)
      this.registryDto.DataNascita = UtilsService.ConvertTo_DATE_DATABASE_FORMAT(this.registryDto.DataNascitaSTR);

    if(this.registryDto.DateIns != null){
      this.registryDto.DateIns = UtilsService.ConvertTo_DATE_DATABASE_FORMAT(this.registryDto.DateInsStr);

      let annoInserimento = +this.registryDto.DateIns.getFullYear();
      let annoAttuale = new Date().getFullYear();
      let anniMembroSapiens = +annoAttuale - annoInserimento;
      if(anniMembroSapiens < 1){

        let meseInserimento = +this.registryDto.DateIns.getMonth();
        let meseAttuale = new Date().getMonth();
        let mesiMembroSapiens = +meseAttuale - meseInserimento;
        if(mesiMembroSapiens < 1){
          this.durataMembroSapiens = "Membro "+ this.worldName +" da meno di 1 mese"
        }else{
          if(mesiMembroSapiens == 1)
            this.durataMembroSapiens = "Membro "+ this.worldName +" da " + mesiMembroSapiens + " mese";
          else
            this.durataMembroSapiens = "Membro "+ this.worldName +" da " + mesiMembroSapiens + " mesi";
        }

      }else{
        this.durataMembroSapiens = "Membro "+ this.worldName +" da " + anniMembroSapiens + " anni";
      }

    }


  }
}
